import { optionSubcategory_view } from './viewSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import AppearanceOption from 'owa-calendar-appearance-option/lib/AppearanceOption';
import BirthdayCalendarOption from 'owa-calendar-birthday-option/lib/BirthdayCalendarOption';
import initializeViewSubCategory from './initializeViewSubCategory';

let viewSubCategory: OptionSubCategory = {
    key: 'view',
    titleStringKey: optionSubcategory_view,
    options: [AppearanceOption, BirthdayCalendarOption],
    onSelected: initializeViewSubCategory,
};

export default viewSubCategory;
